import Country from '~/Api/Country/Country';

import ReferenceBasketVersion from './ReferenceBasketVersion';

interface RawReferenceBasketVersion {
	id: string;
	description: string;
	sinceDate: Date;
	referenceCountries: Country[];
}

export default function mapReferenceBasketVersion(version: RawReferenceBasketVersion): ReferenceBasketVersion {
	return new ReferenceBasketVersion(
		version.id,
		version.description,
		new Date(version.sinceDate),
		version.referenceCountries.map((country) => new Country(country.alpha2, country.name))
	);
}
